// extracted by mini-css-extract-plugin
export default {"onlyDark":"CVSectionHeader_onlyDark__v20QR","onlyLight":"CVSectionHeader_onlyLight__lgcav","cv-section-header":"CVSectionHeader_cv-section-header__4gCpN"};